import { useContext } from 'react';

import { FirebaseContext } from '~/components/partials/FirebaseProvider/context';

export const useFirebase = () => {
  const { firebase, auth, db } = useContext(FirebaseContext);

  return { firebase, auth, db };
};
